import type { TFunction } from 'i18next';

/**
 * A short label for when something recent happened, on the viewer's own
 * clock — chat's convention: a conversation is between people who may be in
 * different places, so "10:42" should match the reader's watch.
 *   - today      → "14:32"
 *   - yesterday  → "Yesterday", in the app's language
 *   - this year  → month and day, e.g. "May 19" / "5月19日"
 *   - older      → the locale's full date, e.g. "2025/5/19"
 *
 * Site operations keep the project's zone (`dateUtils`); this is not for them.
 */
export function formatRecentTime(isoString: string, locale: string, t: TFunction): string {
  const date = new Date(isoString);

  const now = new Date();
  const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayMidnight = new Date(todayMidnight);
  yesterdayMidnight.setDate(yesterdayMidnight.getDate() - 1);

  if (date >= todayMidnight) {
    return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
  }
  if (date >= yesterdayMidnight) return t('common.dates.yesterday');
  if (date.getFullYear() === now.getFullYear()) {
    return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
  }
  return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'numeric', day: 'numeric' }).format(date);
}
